var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKontistLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_27350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01975 10.1942V7.88491H5.33896C6.86307 7.88491 8.28605 8.30362 9.49143 9.07882C9.87236 8.56034 10.2993 8.08672 10.7676 7.63032C9.20907 6.59136 7.34336 6 5.33896 6H1V10.1942C1 14.446 3.7303 18.0815 7.4632 19.5V17.4183C4.87294 16.1006 3.01975 13.3581 3.01975 10.1942ZM19.6623 6C14.9294 6 9.65588 9.7487 9.65588 15.128V19.5H14.5582C16.9365 19.5 19.056 18.4277 20.5265 16.4807C21.8637 14.7102 22.6 12.325 22.6 9.76429V6H19.6623ZM14.5583 17.6591C18.6237 17.6591 20.7508 13.6875 20.7508 9.76425V7.84087H19.6623C17.6761 7.84087 15.6318 8.61565 14.0534 9.96638C12.41 11.373 11.505 13.206 11.505 15.1279V17.6591H14.5583Z",
    fill: "#5A2FB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_27350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4286,
    height: 24,
    fill: "white",
    transform: "translate(1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontistLogo);
export default __webpack_public_path__ + "static/media/kontist-logo.e7291350.svg";
export { ForwardRef as ReactComponent };